// All events happen in the Netherlands, so times are formatted in Amsterdam
// time regardless of where the visitor is.
const TIME_ZONE = 'Europe/Amsterdam';

export function formatEventDate(startsAt) {
  if (!startsAt) return '';
  return new Date(startsAt).toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: TIME_ZONE,
  });
}

export function formatEventTime(startsAt, endsAt) {
  if (!startsAt) return '';
  const time = (value) =>
    new Date(value).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIME_ZONE,
    });
  return endsAt ? `${time(startsAt)}–${time(endsAt)}` : time(startsAt);
}

export function formatPrice(price, currency = 'EUR') {
  if (price === null || price === undefined) return null;
  if (price === 0) return 'Free';
  return new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency,
    minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
  }).format(price);
}
